/** 将后端 FontDTO 映射为平台字体库使用的结构 */

export function mapFontDtoToPlatform(dto = {}) {
  const isSystem = Number(dto.isSystemDefault) === 1;
  const fileUrl = dto.fileUrl || '';
  const fileName = fileUrl.split('/').pop() || dto.fontName || dto.fontFamily || 'font';

  const mapped = {
    id: String(dto.id ?? dto.fontFamily ?? dto.fontName ?? fileName),
    name: dto.fontName || dto.fontFamily || fileName,
    family: dto.fontFamily || dto.fontName || fileName,
    fileName,
    fileUrl,
    fileType: dto.fileType || '',
    previewText: dto.previewText || '',
    previewImgUrl: dto.previewImgUrl || '',
    source: isSystem ? 'system' : 'upload',
    uploadedAt: dto.createTime || '',
    size: dto.fileSize || 0,
    weight: dto.weight || 400,
    style: dto.style || 'normal',
  };
  if (!isSystem) mapped.name = formatPlatformFontName(mapped);
  return mapped;
}

export function mapPlatformFontToUploadPayload(fontMeta = {}, fileUrl = '') {
  const displayName = formatPlatformFontName(fontMeta);
  return {
    fontName: displayName,
    fontFamily: fontMeta.family || fontMeta.fontFamily,
    fileUrl,
    fileType: fontMeta.fileType || fontMeta.fileName?.split('.').pop() || '',
    fileSize: fontMeta.size || fontMeta.fileSize || 0,
    previewText: fontMeta.previewText || displayName,
  };
}

export function unwrapApiResult(payload) {
  if (!payload || typeof payload !== 'object') return payload;
  if (payload.success === false) {
    throw new Error(payload.errorDesc || payload.msg || '请求失败');
  }
  if ('result' in payload) return payload.result;
  if ('data' in payload) return payload.data;
  return payload;
}

/** 字体库展示名：CDP_PDF 技术名转为可读名称 */
export function formatPlatformFontName(font = {}) {
  const preferred = font.displayName || font.fontName;
  if (preferred && !isGarbledFontName(preferred) && !/^CDP_PDF_/i.test(preferred)) {
    return preferred;
  }

  const raw = String(font.name || font.family || font.fileName || '').trim();
  if (!raw) return '未命名字体';

  const cdpMatch = raw.match(/^CDP_PDF_\d+_(.+)$/i);
  if (cdpMatch) {
    const tail = cdpMatch[1]
      .replace(/\.(ttf|otf|woff2?)$/i, '')
      .replace(/[-_]+/g, ' ')
      .trim();
    return tail || 'PDF 内嵌字体';
  }
  if (/^CDP_PDF_/i.test(raw)) return 'PDF 内嵌字体';
  if (isGarbledFontName(raw)) return 'PDF 内嵌字体';
  return raw;
}

/** 编辑器字体下拉名称：沿用字体库可读名规则，并保留字重提示。 */
export function formatEditorFontOption(font = {}) {
  const name = formatPlatformFontName(font);
  const style = String(font.subfamily || '').trim();
  return style && style !== 'Regular' ? `${name} · ${style}` : name;
}

function isGarbledFontName(name) {
  const text = String(name || '').trim();
  if (!text) return true;
  if (text.includes('\uFFFD') || (text.match(/\?/g) || []).length >= 2) return true;
  let readable = 0;
  for (const ch of text) {
    if (/[0-9A-Za-z\u4e00-\u9fff]/.test(ch)) readable += 1;
  }
  return readable < Math.max(2, Math.floor(text.length / 4));
}
